/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react'
import {
    ResizablePanel,
    ResizablePanelGroup,
  } from "@/components/ui/resizable"
import { useQuery } from "@tanstack/react-query";
import AnalyticsDashboard from './AnalyticsDashboard';
import StudiesAnalytics from './StudiesAnalytics';
import MonitoringAdmin from '../admin/Monitoring';
import getAnalyticsData from './getAnalyticsData';
import getStudiesAnalytics from './getStudiesAnalytics';

export default function AnalyticsComp({isOpen, activeTab = 'Dashboard'}) {
    const [timeRange, setTimeRange] = React.useState('30')

    // Analytics data fetching
    const { data: analyticsData, isFetching: isAnalyticsFetching } = useQuery({
		queryKey: ["analytics"],
		queryFn: getAnalyticsData,
		refetchIntervalInBackground: true,
		refetchInterval: 300000,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
	});

    // Studies analytics data fetching
    const { data: studiesData, isFetching: isStudiesFetching } = useQuery({
		queryKey: ["studies-analytics", timeRange],
		queryFn: () => getStudiesAnalytics(timeRange),
		refetchIntervalInBackground: true,
		refetchInterval: 300000,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
	});

  return (
    <div style={{width:'100%', height: '100%'}}>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <h2 style={{fontWeight: 'bolder'}} className='text-xl'>Analytics</h2>
            {/* Future: Add analytics-specific actions */}
            {/* <Button onClick={() => setAddAnalyticsSheet(true)}>+ Generate Report</Button> */}
        </div>
        
        <div className='mt-[2vh] rounded h-[calc(100vh-12rem)] overflow-hidden'>
            <ResizablePanelGroup
                direction="horizontal"
                className={`max-w-md rounded-lg border ${isOpen ? 'min-w-[80vw]' : 'min-w-[94vw]'}`}
                >
                <ResizablePanel defaultSize={100} minSize={60}>
                    {activeTab === 'Dashboard' && (
                        <AnalyticsDashboard 
                            isAnalyticsFetching={isAnalyticsFetching}
                            analyticsData={analyticsData}
                        />
                    )}
                    {activeTab === 'Studies' && (
                        <StudiesAnalytics 
                            isStudiesFetching={isStudiesFetching}
                            studiesData={studiesData}
                            timeRange={timeRange}
                            setTimeRange={setTimeRange}
                        />
                    )}
                    {activeTab === 'Uploads' && (
                        <MonitoringAdmin />
                    )}
                </ResizablePanel>
            </ResizablePanelGroup>
        </div>

        {/* Future: Analytics-specific sheets and modals */}
        {/* <SheetForm 
            open={addAnalyticsSheet}
            close={setAddAnalyticsSheet}
            title="Generate Analytics Report"
            description="Create a new analytics report"
            component={<AnalyticsReportForm setAddAnalyticsSheet={setAddAnalyticsSheet}/>}
            action={handleAnalyticsAction}
        /> */}
        
    </div>
  )
} 